'use client'

import {useAtomValue, useSetAtom} from "jotai";
import {configurationState} from "@/components/Atoms/ConfigurationAtom";
import {useEffect} from "react";
import {eventsState} from "@/components/Atoms/events/EventsAtom";
import {templatesState} from "@/components/Atoms/TemplatesAtom";
import {loadingUserConfigState} from "@/components/Atoms/loadingUserConfig";
import {logout} from "@/lib/auth";
import {lngState} from "@/components/Atoms/LngAtom";
import {configurationType, envVarsType} from "@/lib/definitions/definitions";
import {useQuery} from "react-query";
import {getUser} from "@/lib/fetch/user/getUser";
import toast from "react-hot-toast";
import {getTemplates} from "@/lib/fetch/templates/getTemplates";
import {getCampaigns} from "@/lib/fetch/campaigns/getCampaigns";
import {baseUrlState} from "@/components/Atoms/baseUrlAtom";
import {imageBaseUrlState} from "@/components/Atoms/imageBaseUrlAtom";

export function SaveSelfConfiguration({configuration, envVars}: {
    configuration: string | void,
    envVars: envVarsType
}) {

    const setConfiguration = useSetAtom(configurationState)
    const setEvents = useSetAtom(eventsState)
    const setloadingApp = useSetAtom(loadingUserConfigState)
    const setBaseUrl = useSetAtom(baseUrlState)
    const setImageBaseUrl = useSetAtom(imageBaseUrlState)
    const {lng} = useAtomValue(lngState)
    let baseUrl = ''
    let imageBaseUrl = ''

    useEffect(() => {
        baseUrl = window.location.origin.includes('localhost') ? 'https://demo-liamto.aality.ovh' : window.location.origin
        imageBaseUrl = window.location.origin.includes('localhost') ? 'http://localhost:3000' : window.location.origin
    }, []);

    useEffect(() => {

        if (baseUrl) {
            setBaseUrl(baseUrl)
        }
        if (imageBaseUrl) {
            setImageBaseUrl(imageBaseUrl)
        }
        if (configuration) {
            try {
                const response = JSON.parse(configuration)
                const data = response.data

                if (data) {
                    setEvents(data.events)

                    data.envVars = envVars
                    setConfiguration(data)
                    setloadingApp('loaded')
                }
            } catch (e) {
                console.error('Error in configuration' + e)
            }

        } else {
            console.error('No configuration found')
            logout(lng)
        }
    }, []);

    return null

}